import { c as _c } from "react/compiler-runtime";
import { Button, Popover, Stack, Typography } from '@mui/material';
import { useConditionPanel } from '@/components/conditions/useConditionPanel';
import { findValueCondition } from '@/types/advanceFilter';
import { TagsCondition } from './tagsCondition';
import type { TagsFilterProps } from './tagsFilter';
type TagsConditionSelectorProps = Omit<TagsFilterProps, 'allowChangingFilterMode' | 'onDoneClick' | 'panelTitle'>;
export const TagsConditionSelector = (props: TagsConditionSelectorProps) => {
  const panel = useConditionPanel(props.panelHost, props.onPanelClose);
  const condition = findValueCondition(props.conditions, props.property.name);
  const selectedTags = condition?.value ?? [];
  return <>
      {!panel.isHosted && <Button ref={panel.triggerRef} onClick={panel.open} disableFocusRipple size='small' className='px-0 py-[5px]'>
          <Stack direction={'row-reverse'} className='pl-[12px] pr-[8px]' sx={{
        gap: '8px'
      }}>
            <i className='material-symbols-arrow-drop-down-rounded text-xl align-middle min-w-[22px] min-h-[22px] w-[22px] h-[22px]' />
            {selectedTags.length === 0 && <Typography variant='button' className='text-left font-medium' sx={{
          color: 'var(--mui-palette-text-disabled)'
        }}>
                Select
              </Typography>}
            {selectedTags.length > 0 && <Typography variant='button' className='text-left font-medium' sx={{
          color: 'currentcolor'
        }}>
                {selectedTags.join(', ')}
              </Typography>}
          </Stack>
        </Button>}
      <TagsConditionPanelPopover {...props} anchorEl={panel.anchorEl} popoverOpen={panel.isOpen} selectedTags={selectedTags} onChange={props.onChange} onClose={panel.close} />
    </>;
};
interface TagsConditionPanelPopoverProps extends TagsConditionSelectorProps {
  anchorEl: HTMLElement | null;
  popoverOpen: boolean;
  selectedTags: string[];
  onClose: () => void;
}
const TagsConditionPanelPopover = props => {
  const $ = _c(18);
  let t0;
  if ($[0] !== props) {
    t0 = () => props.onClose();
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      vertical: "bottom",
      horizontal: "left"
    };
    t2 = {
      vertical: "top",
      horizontal: "left"
    };
    t3 = {
      paper: {
        sx: {
          marginTop: "4px"
        }
      }
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.conditions) {
    t4 = [...props.conditions];
    $[5] = props.conditions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props) {
    t5 = () => props.onClose();
    $[7] = props;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== t4 || $[11] !== t5) {
    t6 = <Stack className="w-[308px]"><TagsCondition {...props} conditions={t4} onChange={props.onChange} onDoneClick={t5} /></Stack>;
    $[9] = props;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== props.anchorEl || $[14] !== props.popoverOpen || $[15] !== t0 || $[16] !== t6) {
    t7 = <Popover open={props.popoverOpen} anchorEl={props.anchorEl} onClose={t0} anchorOrigin={t1} transformOrigin={t2} slotProps={t3}>{t6}</Popover>;
    $[13] = props.anchorEl;
    $[14] = props.popoverOpen;
    $[15] = t0;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};